import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { Venmaeparroquia } from '../veninterfaces/venmaeparroquia';
import { Observable } from 'rxjs';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';

@Injectable({
  providedIn: 'root'
})
export class VenmaeparroquiaService {

  public _detparroquia: Venmaeparroquia[];
  get detparroquia(): Venmaeparroquia[] {
    return this._detparroquia;
  }

  set detparroquia(value: Venmaeparroquia[]) {
    this._detparroquia = value;
  }
  private way: string;

  constructor(
    private confIniciales: ConfInicialesService,
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
  ) {
    this.way = sessionStorage.getItem('way');
  }

  getmaeparroquia() {
    return this.http.post<any[]>(this.way + '/ventas/maeparroquia/107772adef1af5000', {
      elementos: {
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarparroquia(item) {
    return this.http.post<any[]>(this.way + '/ventas/maeparroquia/8795b6ab7956f8000000', {
      elementos: {
        p_com_codigo: '01',
        p_PARR_codigo: item.PARR_CODIGO,
        p_PARR_descripcion: item.PARR_DESCRIPCION,
        p_CAN_Codigo: item.CAN_CODIGO
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizarparroquia(item) {
    return this.http.post<any[]>(this.way + '/ventas/maeparroquia/299df2ab2', {
      elementos: {
        p_com_codigo: '01',
        p_PARR_codigo: item.PARR_CODIGO,
        p_PARR_descripcion: item.PARR_DESCRIPCION,
        p_CAN_Codigo: item.CAN_CODIGO
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarparroquia(item) {
    return this.http.post<any[]>(this.way + '/ventas/maeparroquia/7565695d5956f8000000', {
      elementos: {
        p_PARR_codigo: item.PARR_CODIGO,
        p_CAN_Codigo: item.CAN_CODIGO
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
